module.exports = __webpack_public_path__ + "static/media/et_et.d37962d8.png";